import { render, staticRenderFns } from "./addEducation.vue?vue&type=template&id=39043608&"
import script from "./addEducation.vue?vue&type=script&lang=js&"
export * from "./addEducation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports